import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import * as firebase from 'firebase';
import { Globals } from '../../globals';
import { HttpParams, HttpClient } from '@angular/common/http';

//interface
interface Customer {
  UID: string;
  UID_RESTAURANT: string;
  name: string;
  business_name: string;
  business_number: string;
  address: string;
  phone: number;
  email: string;
  note: string;
}


@Injectable()
export class CustomersServices {
  private firestore: any;
  customersCol: AngularFirestoreCollection<Customer>;
  customers: Observable<Customer[]>;
  customerDoc: AngularFirestoreDocument<Customer>;

  public pagesCustomers: any;
  public page_active: number = 1;
  public limit_pages = 100;
  public first_customers_name: any = [];
  public get_customers_done: boolean = false;

  public customers_array: any = [];

  constructor(public afs: AngularFirestore,
    public globals: Globals,
    public http: HttpClient,) {
    this.firestore = firebase.firestore();
  }

  getListCustomers(UID_RESTAURANT) {
    this.customersCol = this.afs.collection('customers', ref => ref.where('UID_RESTAURANT', '==', UID_RESTAURANT).orderBy('name'));
    this.customers = this.customersCol.snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as Customer;
        data.UID = a.payload.doc.id;
        return data;
      });
    });
  }

  async getCustomer(uid) {

    const restRef = this.firestore.collection('customers').doc(uid);

    var _num;

    await restRef.get().then(doc => {
      _num = doc.data();
      _num.UID = doc.id;
    });

    return _num

  }

  async getCustomers(UID_RESTAURANT) {
    const restRef = this.firestore.collection('customers');
    var customers = [];

    await restRef.where('UID_RESTAURANT', '==', UID_RESTAURANT).get()
      .then(snapshot => {
        snapshot.forEach(doc => {
          var customer = doc.data();
          customer.UID = doc.id;
          customers.push(customer);
        });
      });

    return customers;
  }

  public tickets_searchbar_text: string = '';
  public get_tickets_done: boolean = false;
  public tickets_array: any = [];
  public tickets_array_tmp: any = [];
  public tickets_array_filtered: any = [];
  public list_tickets_array: any = [];

  async getPagesCustomerTickets(customer_uid) {
    this.get_tickets_done = false;

    const params = new HttpParams()
      .set('restaurant_uid', this.globals.restaurant_uid)
      .set('customer_uid', customer_uid);
    await this.http.post(this.globals.analytics_path + 'customers/customer_paginate_tickets', params, {})
      .subscribe(async res => {
        this.tickets_array = res['list'];
        this.tickets_array_tmp = res['list'];
        this.getCustomerListTickets();
      });
  }

  getCustomerListTickets() {
    this.get_tickets_done = true;
    this.list_tickets_array = this.tickets_array_tmp;
    this.tickets_array_filtered = this.tickets_array_tmp;
    this.ticketsSearch(this.tickets_searchbar_text);
  }

  ticketsSearch(value) {
    if (value) {
      this.tickets_array_filtered = this.list_tickets_array.filter(objeto => {
        return this.globals.objectToArray(objeto).some(valor => {
          if (typeof valor === 'string' || typeof valor === 'number') {
            // Comparar como string
            return valor.toString().toLowerCase().includes(value.toLowerCase());
          } else if (Array.isArray(valor)) {
            // Buscar en cada elemento del array
            return valor.some(elemento => elemento.toString().toLowerCase().includes(value.toLowerCase()));
          }
          return false;
        });
      });
    } else {
      this.tickets_array_filtered = this.list_tickets_array;
    }
  }

  public invoices_searchbar_text: string = '';
  public get_invoices_done: boolean = false;
  public invoices_array: any = [];
  public invoices_array_tmp: any = [];
  public invoices_array_filtered: any = [];
  public list_invoices_array: any = [];
  async getPagesCustomerInvoices(customer_uid) {
    this.get_invoices_done = false;
    const params = new HttpParams()
      .set('restaurant_uid', this.globals.restaurant_uid)
      .set('customer_uid', customer_uid);

    await this.http.post(this.globals.analytics_path + 'customers/customer_paginate_invoices', params, {})
      .subscribe(async res => {
        this.invoices_array = res['list'];
        this.invoices_array_tmp = res['list'];
        this.getListInvoices();
      });
  }
  getListInvoices() {
    this.get_invoices_done = true;
    this.list_invoices_array = this.invoices_array_tmp;
    this.invoices_array_filtered = this.invoices_array_tmp;
    this.invoicesSearch(this.invoices_searchbar_text);
  }

  invoicesSearch(value) {
    if (value) {
      this.invoices_array_filtered = this.list_invoices_array.filter(objeto => {
        return this.globals.objectToArray(objeto).some(valor => {
          if (typeof valor === 'string' || typeof valor === 'number') {
            // Comparar como string
            return valor.toString().toLowerCase().includes(value.toLowerCase());
          } else if (Array.isArray(valor)) {
            // Buscar en cada elemento del array
            return valor.some(elemento => elemento.toString().toLowerCase().includes(value.toLowerCase()));
          }
          return false;
        });
      });
    } else {
      this.invoices_array_filtered = this.list_invoices_array;
    }
  }

  async addNewCustomer(data) {
    const newDocRef = await this.afs.collection('customers').add(data);
    var newCustomerId = newDocRef.id;
    return newCustomerId;
  }


  get_cusotmer_done: boolean = false;
  customers_array_tmp: any = [];
  list_customers_array: any = [];
  customers_array_filtered: any = [];
  customer_searchbar_text: any = '';

  async getNodeCustomers() {
    this.get_customers_done = false;
    const params = new HttpParams()
      .set('uid', this.globals.restaurant_uid);
    await this.http.post(this.globals.analytics_path + 'paginate/customer', params, {})
      .subscribe(async res => {

        this.customers_array_tmp = res['list'];

        if (this.customers_array_tmp.length != 0) {
          this.getListCustomersMinMax();
        } else {
          this.get_cusotmer_done = true;
        }

      });
  }

  getListCustomersMinMax() {
    this.get_customers_done = true;
    this.list_customers_array = this.customers_array_tmp;
    this.customers_array_filtered = this.customers_array_tmp;
    this.customerSearch(this.customer_searchbar_text);
  }

  customerSearch(value) {
    if (value) {
      this.customers_array_filtered = this.list_customers_array.filter(objeto => {
        return this.globals.objectToArray(objeto).some(valor => {
          if (typeof valor === 'string' || typeof valor === 'number') {
            // Comparar como string
            return valor.toString().toLowerCase().includes(value.toLowerCase());
          } else if (Array.isArray(valor)) {
            // Buscar en cada elemento del array
            return valor.some(elemento => elemento.toString().toLowerCase().includes(value.toLowerCase()));
          }
          return false;
        });
      });
    } else {
      this.customers_array_filtered = this.list_customers_array;
    }
  }


}



// WEBPACK FOOTER //
// ./src/pages/customers/services.ts